import React from 'react';
import { Link } from 'react-router';
import { footerLinks } from './constant';

const FatFooter = (props) => (
  <footer className="big-footer">
    <div className="top-nav footer-wrapper">
      <div className="top row container">
        <div className='footer-sc-logo-wrapper'>
          <div className="footer-sc-logo"></div>
        </div>
        <div className='footer-link-wrapper'>
          {footerLinks.map(item =>
            <div className="footer-link-box">
              <div className='footer-link-label'>
                {item.title}
              </div>
              {item.links.map(link => (
                link.external ?
                  <div className="footer-link">
                    <a id={link.id} href={link.url} target={link.target ? link.target : ""}>
                      {link.icon && <img width={14} height={14} style={{ marginRight: '10px', marginBottom: '5px' }} src={link.icon} alt="" />}
                      {link.label}
                    </a>
                  </div>
                  :
                  <div className="footer-link">
                    <Link id={link.id} to={link.url}>{link.label}</Link>
                  </div>
              ))}
            </div>
          )}
          <div className="">
            <div className='footer-link-label'>
              Download the ShippingCart App
            </div>
            <div className='footer-sc-app'>
              <img width={96} height={96} src="https://cdn.shippingcart.com/assets/qr_code-opt-20211214073949.png" alt=""/>
              <div className='footer-sc-app-button'>
                <a href='https://sc-app-launch.onelink.me/im4v' target="_blank" rel="noopener noreferrer">
                  <img width={96} height={30} src="https://cdn.shippingcart.com/assets/google-play-20200601054551.png" alt="" />
                </a>
                <a href='https://sc-app-launch.onelink.me/im4v' target="_blank" rel="noopener noreferrer">
                  <img width={96} height={30} src="https://cdn.shippingcart.com/assets/apple-store-opt-20211214073949.png" alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className='footer-mobile-link-wrapper'>
          {footerLinks.filter(item => item.title === 'Social Media').map(item =>
            <div className="footer-link-box">
              <div className='footer-link-label'>
                {item.title}
              </div>
              <div className='footer-mobile-link'>
                {item.links.map(link => (
                  <div className="footer-link">
                    <a href={link.url} target={link.target ? link.target : ""}>
                      {link.icon && <img width={14} height={14} style={{ marginRight: '10px', marginBottom: '5px' }} src={link.icon} alt="" />}
                    </a>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className="">
            <div className='footer-link-label'>
              Download the ShippingCart App
            </div>
            <div className='footer-sc-app'>
              <div className='footer-sc-app-button'>
                <a href='https://sc-app-launch.onelink.me/im4v' style={{ marginRight: '10px' }} target="_blank" rel="noopener noreferrer">
                  <img width={96} height={30} src="https://cdn.shippingcart.com/assets/google-play-20200601054551.png" alt="" />
                </a>
                <a href='https://sc-app-launch.onelink.me/im4v' target="_blank" rel="noopener noreferrer">
                  <img width={96} height={30} src="https://cdn.shippingcart.com/assets/apple-store-opt-20211214073949.png" alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className='footer-bottom-wrapper'>
      <div className="">
        <span>Copyright &copy; {props.currentYear} ShippingCart.</span>
      </div>
      <div className='footer-bottom-link-wrapper'>
        <div className='footer-bottom-link'>
          <Link to="/terms-conditions">Terms and Condition</Link>
        </div>
        <div>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default FatFooter;



/** WEBPACK FOOTER **
 ** ./src/components/Layout/Footer/FatFooter.js
 **/